export const PRIVACY_POLICY_URL = '/legal/privacy-policy/';
export const PERSONAL_DATA_URL = '/legal/personal-data-agreement/';
export const PHONE_MASK = '+7 (000) 000-00-00';
